import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';

// Importaciones de componentes.
import { LicenseSettingsComponent } from './license-settings.component';

@NgModule({
  declarations: [LicenseSettingsComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSortModule,
    MatIconModule,
  ],
})
export class LicenseSettingsModule {}
